import { apiSlice } from "..";
import { getToken } from "shared/utils/getToken";

export interface BlackListRegistro {
  idBlackList: number;
  nome: string;
  email: string;
}

export interface BlackListPayload {
  nome: string;
  email?: string;
}

export interface BlackListResponse {
  totalElementos: number;
  quantidadePaginas: number;
  pagina: number;
  tamanho: number;
  elementos: BlackListRegistro[];
}

export interface BlackListPagination {
  pagina: number;
  tamanho?: number;
  filtro?: string;
}

export interface UpdateBlackListRequest {
  idBlackList: number;
  body: BlackListPayload;
}

const blackListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBlackList: builder.query<BlackListResponse, BlackListPagination>({
      query: ({ pagina, tamanho = 10, filtro }) => ({
        url: "black-list",
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          pagina,
          tamanho,
          sort: "nome",
          order: 0,
          ...(filtro ? { filtro } : {}),
        },
      }),
      providesTags: ["BlackList"],
    }),
    getBlackListById: builder.query<BlackListRegistro, number>({
      query: (idBlackList) => ({
        url: `black-list/${idBlackList}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      providesTags: (result, error, idBlackList) => [
        { type: "BlackList", id: idBlackList },
      ],
    }),
    postBlackList: builder.mutation<void, BlackListPayload>({
      query: (body) => ({
        url: "black-list",
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body,
      }),
      invalidatesTags: ["BlackList"],
    }),
    updateBlackList: builder.mutation<void, UpdateBlackListRequest>({
      query: ({ idBlackList, body }) => ({
        url: `black-list/${idBlackList}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        "BlackList",
        { type: "BlackList" as const, id: arg.idBlackList },
      ],
    }),
    deleteBlackList: builder.mutation<void, number>({
      query: (idBlackList) => ({
        url: `black-list/${idBlackList}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      invalidatesTags: ["BlackList"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBlackListQuery,
  useGetBlackListByIdQuery,
  usePostBlackListMutation,
  useUpdateBlackListMutation,
  useDeleteBlackListMutation,
} = blackListSlice;
